'use strict';

import React from 'react';

/**
 * @extends {React.Component}
 */
class ModalContent extends React.Component {

  /**
   * @return {JSX} JSX component markup.
   */
  render () {
    const { children } = this.props;
    return (
      <div className="Modal-contentScroll">
        <div className="Modal-content">
          { children }
        </div>
      </div>
    );
  }
}

/**
 * @prop {propTypes} propTypes attributes for the Modal component
 */
ModalContent.propTypes = {};

ModalContent.defaultProps = {};

export default ModalContent;



// WEBPACK FOOTER //
// ./src/components/clarity-ui/components/modal/modalContent.jsx